import React, { useEffect } from "react";
import { Box } from "@mui/material";
import useSWRInfinite from "swr/infinite";
import { useInView } from "react-intersection-observer";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router";

import {
  // getSettingState,
  setLoadNavigation,
} from "../../../../../redux/features/settingSlice";
import LoadingCart from "../LoadingCart";
// import DetailCart from "../DetailCart";
// import EmptyState from "../../../EmptyState";
// import { emptyStateProfile } from "../../../../../utils/EmptyStateProfile";
import NewDetailCart from "./../NewDetailCart/index";
import { fetcherGetToken } from "../../../../../services/fetcher";

const OpinionBox = ({ data }) => {
  const dispatch = useDispatch();
  // const { userData, profileTab } = useSelector(getSettingState);
  const location = useLocation();
  let urlParams = location.pathname.split("/");
  const myProfile = !urlParams[2];
  const tokenStorage = JSON.parse(localStorage.getItem("token")) || null;

  const { ref, inView } = useInView({
    /* Optional options */
    threshold: 0,
  });

  const {
    data: opinion,
    isLoading,
    isValidating,
    size,
    setSize,
  } = useSWRInfinite(
    (pageIndex, previousPageData) => {
      if (previousPageData && !previousPageData.results.length) return null;

      return [
        `${process.env.REACT_APP_API}/content/profile/participated-opinions/${
          data.id
        }/?page=${pageIndex + 1}`,
        tokenStorage,
      ];
    },
    fetcherGetToken,
    {
      revalidateFirstPage: true,
    }
  );

  useEffect(() => {
    !isLoading && dispatch(setLoadNavigation(isValidating));
  }, [dispatch, isLoading, isValidating]);

  useEffect(() => {
    inView && moreInfinite();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView]);

  const moreInfinite = () => {
    const moreOpinionCart = size + 1 <= opinion[0]?.total_pages;
    if (moreOpinionCart) {
      setSize(size + 1);
      dispatch(setLoadNavigation(true));
    } else {
      // setSize(opinion[0].total_pages);
    }
  };

  const opinionsList = () => {
    let opinionList = [];
    if (opinion) {
      // eslint-disable-next-line array-callback-return
      opinion.map((e) => {
        opinionList.push(...e.results);
      });
    }
    return opinionList;
  };

  return (
    <Box>
      {(isLoading || !opinion) && !myProfile && <LoadingCart type='opinion' />}
      {!isLoading &&
        opinion &&
        opinionsList().map((row) => {
          return <NewDetailCart key={row.pk} type='opinion' rowData={row} />;
        })}
      {/* {!isLoading &&
        opinionsList().length === 0 &&
        (!userData || opinion) &&
        !isValidating && (
          <EmptyState
            title={
              emptyStateProfile(
                userData,
                data?.followed,
                myProfile,
                profileTab,
                opinion
              ).title
            }
            dis={
              emptyStateProfile(
                userData,
                data?.followed,
                myProfile,
                profileTab,
                opinion
              ).dis
            }
            btn1={
              emptyStateProfile(
                userData,
                data?.followed,
                myProfile,
                profileTab,
                opinion
              ).btn1
            }
            btn2={
              emptyStateProfile(
                userData,
                data?.followed,
                myProfile,
                profileTab,
                opinion
              ).btn2
            }
          />
        )} */}
      {!isLoading && opinion && (
        <Box ref={ref} sx={{ display: "flex", justifyContent: "center" }}></Box>
      )}
    </Box>
  );
};
export default OpinionBox;
